import React, { useState, useContext, useEffect, useRef } from "react";
import { withRouter, useHistory, Link } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import CartContext from "../../context/cart/CartContext";
import GroupContext from "../../context/group/GroupContext";
import SubscribeContext from "../../context/subscribe/SubscribeContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import CompCardContext from "../../context/comp-card/CompCardContext";
import useForm from "../../hooks/useForm";
// import PopupMessage from "../common/PopupMessage";
import ReCAPTCHA from "react-google-recaptcha";
import { env } from "../../env";

const LoginControl = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);
  const groupContext = useContext(GroupContext);
  const subscribeContext = useContext(SubscribeContext);
  const employeeContext = useContext(EmployeeContext);
  const compCardContext = useContext(CompCardContext);

  const { resetCardState } = cardContext;
  const { resetCartState } = cartContext;
  const { resetSubscribeState } = subscribeContext;
  const { resetGroupState } = groupContext;
  const { resetEmployeeState } = employeeContext;
  const { resetCompCardState } = compCardContext;
  const { getConfigValueByCode, getConfigValueByName, loaded } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { login } = authContext;

  const history = useHistory();

  // useEffect(() => {
  //   // if (isAuthenticated) {
  //   //   history.push("/home");
  //   // }
  //   if (error) {
  //     clearAlerts();
  //     let errMsg =
  //       error.response.status === 401
  //         ? "Invalid Username or Password"
  //         : "Unexpected error occured";
  //     console.log("Error::::", JSON.stringify(error));
  //     setAlert(errMsg, "danger");
  //     // clearErrors();
  //   }
  //   //eslint-disable-next-line
  // }, [
  //   error,
  //   // isAuthenticated,
  //   // props.history
  // ]);
  const [user, setUser] = useState({
    username: "",
    password: "",
  });
  const [labels, setLabels] = useState({
    username: "Username",
    password: "Password",
  });
  const [captcha, setCaptcha] = useState(false);

  const { username, password } = user;

  const onChange = (e) => {
    let val = e.target.value.trim();
    setUser({ ...user, [e.target.name]: val });
    if (e.target.name === "username") {
      usernameRef.current.value = val;
    } else if (e.target.name === "password") {
      passwordRef.current.value = val;
    }
    console.log("trim", val);
  };

  const onCaptcha = (value) => {
    console.log(value);
    if (value) {
      setCaptcha(true);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    clearAlerts();
    resetCardState();
    resetCartState();
    resetSubscribeState();
    resetGroupState();
    resetEmployeeState();
    resetCompCardState();
    clearAlerts();
    try {
      const user = await login({
        username,
        password,
      });
      console.log("$$User", user);
      if (user && user.status !== "ERROR") {
        history.push("/account");
      } else if (user && user.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          user.msgCode
        );
        setAlert(msg, "danger");
      } else {
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
      // if (user && user.sponsor) {
      //   history.push("/account");
      // } else {
      //   // history.push("/cards");
      // }
      // loadUserCards({}, token);
    } catch (err) {
      console.log("$$ERROR", JSON.stringify(err));
      // let errMsg =
      //   error && error.response.status === 401
      //     ? "Invalid Username or Password"
      //     : "Invalid Username or Password";
      // // console.log("Error::::", JSON.stringify(error));
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  useEffect(
    () => {}, //eslint-disable-next-line
    [usernameRef.current, passwordRef.current]
  );

  // const isValidEmail = (value) => {
  //   const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  //   return !regex.test(value) ? "is not a valid email" : "";
  // };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      username: usernameRef,
      password: passwordRef,
    },
    screenName: "login",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (loaded) {
      let username = getConfigValueByName(
        "patronConfig",
        "Label",
        "label.username"
      );
      let password = getConfigValueByName(
        "generalConfig",
        "Label",
        "label.password"
      );
      setLabels({ ...labels, username, password });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  return (
    <aside className="sidebar__login login-card">
      <h2 className="sidebar__login__title">
        LOGIN TO RELOAD YOUR REGISTERED FARE CARD
      </h2>
      <Popup role="alert" aria-relevant="all" />
      <form className="sidebar__login__form" autoComplete="off" noValidate>
        <label htmlFor="username" className="sidebar__login__form__label">
          {labels.username} :
        </label>
        <div id="formUserName" className="sidebar__login__form__input">
          <i
            className="fa fa-user fa-lg fa-fw sidebar__login__form__input__icon"
            aria-hidden="true"
          ></i>
          <input
            className="sidebar__login__form__input__control"
            type="text"
            name="username"
            id="username"
            onChange={onChange}
            placeholder={labels.username}
            onBlur={validateField}
            ref={usernameRef}
            aria-required="true"
          />
        </div>
        <label htmlFor="password" className="sidebar__login__form__label">
          {labels.password} :
        </label>
        <div id="formPassword" className="sidebar__login__form__input">
          <i
            className="fa fa-lock fa-lg fa-fw sidebar__login__form__input__icon"
            aria-hidden="true"
          ></i>
          <input
            className="sidebar__login__form__input__control"
            type="password"
            name="password"
            id="password"
            onChange={onChange}
            placeholder={labels.password}
            onBlur={validateField}
            ref={passwordRef}
            aria-required="true"
            autoComplete="off"
          />
        </div>
        <ReCAPTCHA
          aria-label="google captcha"
          className="google"
          sitekey={env.REACT_APP_HMW_GGL_RECAPTCHA_KEY}
          onChange={onCaptcha}
          onExpired={() => setCaptcha(false)}
        />
        <div>
          <input
            type="submit"
            value="Login"
            className="btn btn-primary sidebar__login__form__button"
            onClick={onSubmit}
            disabled={!(isFormValid && captcha)}
          />
        </div>
        <div>
          <Link
            className="sidebar__login__link"
            to="/forgot-password"
            role="link"
          >
            Forgot Password?
          </Link>
        </div>
      </form>
    </aside>
  );
};

export default withRouter(LoginControl);
